import type { EventType, Emitter as Mitt } from "mitt"
import mitt from "mitt"

interface Events {
	"open:invitation-request": { patient_id: number }
	"appointment:saved": undefined
}

export const emitter = mitt<Omit<Events, "">>()
export type Emitter<T extends Record<EventType, unknown>> = Mitt<T>
